import React, { useState } from 'react';
import toast from 'react-hot-toast';

import { Copy, CopyFilled } from '@/resources/assets/images';
import './CopyToClipboard.scss';

const MILLISECONDS_TO_FADE = 1500;

type CopyToClipboardProps = {
	textToCopy: string;
	type?: string;
};

export default function CopyToClipboard({
	textToCopy,
	type
}: CopyToClipboardProps) {
	const [clicked, setClicked] = useState(false);

	function handleCopy() {
		setClicked(true);
		navigator.clipboard.writeText(textToCopy);
		toast.success(
			type
				? `${type} has been successfully copied to the clipboard`
				: 'Copied to clipboard successfully'
		);
		setTimeout(() => {
			setClicked(false);
		}, MILLISECONDS_TO_FADE);
	}

	return (
		<div className={`${clicked && 'opacity-70'} flex items-center gap-1`}>
			<button onClick={handleCopy} className="copy-button">
				<Copy className="copy-icon" />
				<CopyFilled className="copy-icon-filled" />
			</button>
			<span className="copy-tooltip text-xs font-bold text-orange">
				Copy to clipboard
			</span>
		</div>
	);
}
